import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BreadCrumbStateService } from '@go-modules/services/breadcrumb-state/breadcrumb-state.service';
import { States } from '@go-modules/enums/states';
@Component({
	selector: 'breadcrumbs',
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['./breadcrumbs.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BreadCrumbsComponent {

	public VerticalNavState = States;

	constructor (
		public breadCrumbStateService: BreadCrumbStateService
	) {}
}
